<div>
    <app-pdf-viewer *ngIf="!file?.isSupportedImageType" #pdfViewer></app-pdf-viewer>
    <img
        *ngIf="file?.isSupportedImageType && documentImageFilePath"
        [ngStyle]="{ maxHeight: maxHeight ? maxHeight + 'px' : 'initial' }"
        [src]="documentImageFilePath"
        [alt]="file.name"
    />
</div>
